import styles from "../styles/StepOne.module.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useRef, useCallback, useState, forwardRef, useEffect } from "react";
import {
    GoogleMap,
    // DirectionsRenderer,
    Autocomplete,
    DirectionsService,
    LoadScript,
    DirectionsRenderer,
} from "@react-google-maps/api";
import MapsComponent from "./MapsComponent";
import { useLocation } from "react-router-dom";
import AppLoader from "./AppLoader";

// const mapContainerStyle = {
//     width: "100%",
//     height: "400px",
// };

// const center = {
//     lat: 51.5072,
//     lng: -0.1276,
// };

const StepOne = ({
    origin,
    setOrigin,
    destination,
    setDestination,
    distance,
    setDistance,
    duration,
    setDuration,
    directions,
    setDirections,
    setStep,
    formValues,
    setFormValues,
}) => {
    const autocompleteOrigin = useRef(null);
    const autocompleteDestination = useRef(null);

    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const validateForm = () => {
        let errors = {};

        if (!origin) {
            errors.originError = "Please enter pick up location";
        }

        if (formValues.type === "distance" && !destination) {
            errors.destinationError = "Please enter drop off location.";
        }

        if (
            formValues.type === "hourly" &&
            (!formValues.hours ||
                parseInt(formValues.hours) < 3 ||
                parseInt(formValues.hours) > 24)
        ) {
            errors.hoursError = "Please enter valid hours. (3 - 24)";
        }

        if (!formValues.pickUpDate) {
            errors.dateError = "Enter a pick up date.";
        }

        if (!formValues.pickUpTime) {
            errors.timeError = "Enter a pick up time.";
        }

        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    // const handlesetDate = (date) => {
    //     setDate(date)
    //     setFormValues({ ...formValues, Cal_Date: date })
    // }

    // const [date, setDate] = useState(new Date());
    // const [startTime, setStartTime] = useState(new Date());

    const handleOriginSelect = (place) => {
        if (errors.hasOwnProperty(["originError"])) {
            delete errors.originError;
        }
        console.log(place);
        setOrigin(place);
    };

    const handleDestinationSelect = (place) => {
        if (errors.hasOwnProperty(["destinationError"])) {
            delete errors.destinationError;
        }
        console.log(place);
        setDestination(place);
    };

    const londonBounds = {
        // The latitude and longitude bounds for Greater London
        // These can be adjusted as needed
        north: 51.693788,
        south: 51.276303,
        east: 0.334015,
        west: -0.510375,
    };

    useEffect(() => {
        if (queryParams.size > 8) {
            if (
                origin &&
                ((formValues.type === "distance" && destination && distance) ||
                    (formValues.type === "hourly" && formValues.hours)) &&
                formValues.pickUpDate &&
                formValues.pickUpTime
            ) {
                setIsLoading(validateForm() ? "true" : "false");
                validateForm() ? setStep(2) : setStep(1);
            }
        } else {
            setIsLoading(false);
        }
    }, [origin, destination, distance, formValues]);

    // const directionsCallback = useCallback((response) => {
    //     if (response !== null && response.status === "OK") {
    //         const longestRoute = response.routes.reduce((a, b) => {
    //             const aDistance = a.legs.reduce(
    //                 (acc, leg) => acc + leg.distance.value,
    //                 0
    //             );
    //             const bDistance = b.legs.reduce(
    //                 (acc, leg) => acc + leg.distance.value,
    //                 0
    //             );
    //             return aDistance > bDistance ? a : b;
    //         });
    //         setDirections(response);
    //         setDistance(longestRoute.legs[0].distance.text);
    //         setDuration(longestRoute.legs[0].duration.text);
    //     }
    // }, []);

    // const [calendarClose, setCalendarClose] = useState(false);
    // const [errors, setErrors] = useState({});
    // const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (

    //     // <button
    //     //     className={`${styles.dateTimeBtn}`}
    //     //     // onClick={() => setShowDatePicker(!showDatePicker)}
    //     //     onClick={onClick}
    //     //     ref={ref}
    //     // >
    //     //     {formValues.DateTime && calendarClose
    //     //         ? "Change Date & Time"
    //     //         : "Choose Date & Time"}
    //     // </button>
    // ));

    // const handleSelect = () => {
    //     console.log("Date is Selected: ", formValues.DateTime);
    // };
    // const validateForm = () => {
    //     let errors = {};
    //     if (!formValues.DateTime) {
    //         errors.DateTime = "Date and time are required";
    //     }
    //     setErrors(errors);
    //     return Object.keys(errors).length === 0;
    // };
    // console.log("duration", duration)
    // console.log('dateandtime', formValues.DateTime)

    return (
        <>
            {isLoading && <AppLoader />}
            <div className="container">
                <nav className="container text-center">
                    <img
                        className="img-fluid pt-4"
                        src="images/logo.svg"
                        alt="pegasus chauffeur"
                    />
                    <p className={`my-5 py-3 text-white ${styles.heading}`}>
                        Use the form below to check the pricing for our all
                        available vehicles. Smart, Secure, Online Payment System
                        designed for our valuable customers.
                    </p>
                </nav>

                <img
                    src="images/navigation-bar.svg"
                    alt="first step"
                    className="img-fluid mb-5"
                />
                <div className="row py-5">
                    <div className={`col-lg-6 ${styles.box}`}>
                        <div className="d-flex justify-content-between mb-5">
                            <div
                                className={
                                    formValues.type === "distance"
                                        ? `${styles.active} ${styles.tab}`
                                        : `${styles.inactive} ${styles.tab}`
                                }
                                onClick={() => {
                                    setFormValues({
                                        ...formValues,
                                        type: "distance",
                                    });
                                    setOrigin(null);
                                    setDestination(null);
                                    setDistance(null);
                                    setDuration(null);
                                }}
                            >
                                <div className={`${styles.tooltip}`}>
                                    <span>Distance</span>
                                    <span className={`${styles.tooltiptext}`}>
                                        This is to travel from A to B in Central
                                        London
                                    </span>
                                </div>
                                {formValues.type === "distance" ? (
                                    <img
                                        src="images/triangle.svg"
                                        alt="Selected"
                                        className={styles.triangle}
                                    />
                                ) : (
                                    ""
                                )}
                            </div>
                            <div
                                className={
                                    formValues.type === "hourly"
                                        ? `${styles.active} ${styles.tab}`
                                        : `${styles.inactive} ${styles.tab}`
                                }
                                onClick={() => {
                                    setFormValues((prev) => ({
                                        ...prev,
                                        type: "hourly",
                                    }));
                                    setOrigin(null);
                                    setDestination(null);
                                    setDistance(null);
                                    setDuration(null);
                                }}
                            >
                                {formValues.type === "hourly" ? (
                                    <img
                                        src="images/triangle.svg"
                                        alt="Selected"
                                        className={styles.triangle}
                                    />
                                ) : (
                                    ""
                                )}
                                <div className={`${styles.tooltip}`}>
                                    <span>Hourly</span>{" "}
                                    <span className={`${styles.tooltiptext}`}>
                                        This is to book car on per hour basis.
                                        Allowance is 10 miles per hour Central
                                        London
                                    </span>
                                </div>
                            </div>
                            <div className={`${styles.inactive} ${styles.tab}`}>
                                <a href="https://pegasuschauffeur.com/get-a-quote/">
                                    <span>Tailored Solution</span>
                                </a>
                            </div>
                        </div>
                        <div className={styles.inputWrapper}>
                            <label className={`${styles.formLabel}`}>
                                Where from?
                            </label>
                            <br />
                            <img
                                src="images/location-icon.png"
                                className={styles.inputIcon}
                                alt="location icon"
                            />
                            <Autocomplete
                                onLoad={(autocomplete) =>
                                    (autocompleteOrigin.current = autocomplete)
                                }
                                onPlaceChanged={() =>
                                    handleOriginSelect(
                                        autocompleteOrigin.current.getPlace()
                                    )
                                }
                                options={{
                                    bounds: londonBounds,
                                    componentRestrictions: { country: "uk" },
                                }}
                            >
                                <input
                                    type="text"
                                    placeholder="Enter Location"
                                    className={styles.formInput}
                                    defaultValue={origin?.formatted_address}
                                />
                            </Autocomplete>
                            {errors.originError && (
                                <span className={styles.starick}>
                                    {errors.originError}
                                </span>
                            )}
                        </div>
                        {formValues.type === "distance" ? (
                            <div className={styles.inputWrapper}>
                                <label className={`${styles.formLabel}`}>
                                    Where to?
                                </label>
                                <br />
                                <img
                                    src="images/location-icon.png"
                                    className={styles.inputIcon}
                                    alt="location icon"
                                />
                                <Autocomplete
                                    onLoad={(autocomplete) =>
                                        (autocompleteDestination.current =
                                            autocomplete)
                                    }
                                    onPlaceChanged={() =>
                                        handleDestinationSelect(
                                            autocompleteDestination.current.getPlace()
                                        )
                                    }
                                    options={{
                                        bounds: londonBounds,
                                        componentRestrictions: {
                                            country: "uk",
                                        },
                                    }}
                                >
                                    <input
                                        type="text"
                                        className={styles.formInput}
                                        placeholder="Enter Destination Address"
                                        defaultValue={
                                            destination?.formatted_address
                                        }
                                    />
                                </Autocomplete>
                                {errors.destinationError && (
                                    <span className={styles.starick}>
                                        {errors.destinationError}
                                    </span>
                                )}
                            </div>
                        ) : (
                            ""
                        )}
                        {formValues.type === "hourly" ? (
                            <div className={styles.inputWrapper}>
                                <label className={`${styles.formLabel}`}>
                                    Number of hours?
                                </label>
                                <input
                                    className={styles.formInput}
                                    style={{ padding: "0.5rem" }}
                                    type="number"
                                    name="hours"
                                    id="hours"
                                    min={3}
                                    max={24}
                                    placeholder="Minimum number of hours is 3"
                                    defaultValue={formValues.hours}
                                    onChange={(e) => {
                                        if (
                                            errors.hasOwnProperty([
                                                "hoursError",
                                            ])
                                        ) {
                                            delete errors.hoursError;
                                        }
                                        setFormValues({
                                            ...formValues,
                                            [e.target.name]: e.target.value,
                                        });
                                    }}
                                />
                                {errors.hoursError && (
                                    <span className={styles.starick}>
                                        {errors.hoursError}
                                    </span>
                                )}
                            </div>
                        ) : (
                            ""
                        )}
                        {/* calender  */}
                        <div className="row">
                            <div className="col-lg-6 mt-1">
                                <label className={`${styles.formLabel}`}>
                                    Pickup Date:{" "}
                                    <span style={{ color: "red" }}>*</span>
                                </label>
                                <br />
                                <DatePicker
                                    className={`${styles.formInput1}`}
                                    selected={formValues.Cal_Date}
                                    onChange={(date) => {
                                        if (
                                            errors.hasOwnProperty(["dateError"])
                                        ) {
                                            delete errors[["dateError"]];
                                        }
                                        setFormValues({
                                            ...formValues,
                                            Cal_Date: date,
                                            pickUpDate: date.toDateString(),
                                        });
                                    }}
                                    minDate={new Date()}
                                    locale="en"
                                    // showIcon={true}
                                    showDateSelect
                                    // timeFormat="p"
                                    // timeIntervals={15}
                                    // dateFormat="Pp"
                                    dateFormat="MM/dd/yyyy"
                                    closeOnScroll={(e) => e.target === document}
                                    // customInput={<ExampleCustomInput />}
                                    // className={styles.datePicker}
                                    // onSelect={handleSelect}
                                    required
                                />
                                {errors.dateError && (
                                    <span className={styles.starick}>
                                        {errors.dateError}
                                    </span>
                                )}
                                <br />
                            </div>
                            <div className="col-lg-6 mt-1">
                                <label className={`${styles.formLabel}`}>
                                    Pickup Time:{" "}
                                    <span style={{ color: "red" }}>*</span>
                                </label>
                                <br />
                                <DatePicker
                                    className={styles.formInput1}
                                    selected={formValues.Cal_Time}
                                    onChange={(date) => {
                                        // console.log('time selected:', date.toLocaleTimeString())
                                        if (
                                            errors.hasOwnProperty(["timeError"])
                                        ) {
                                            delete errors[["timeError"]];
                                        }
                                        setFormValues({
                                            ...formValues,
                                            Cal_Time: date,
                                            pickUpTime:
                                                date.toLocaleTimeString(),
                                        });
                                    }}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={15}
                                    timeCaption="Time"
                                    dateFormat="h:mm aa"
                                />
                                {errors.timeError && (
                                    <span className={styles.starick}>
                                        {errors.timeError}
                                    </span>
                                )}
                            </div>
                        </div>
                        <button
                            className={`${styles.btn}`}
                            onClick={() =>
                                validateForm() ? setStep(2) : setStep(1)
                            }
                        >
                            Calculate and Pay
                        </button>
                    </div>
                    <br />
                    <div className="col-lg-6">
                        <div>
                            {origin && destination ? (
                                // <iframe
                                //     title="Google Maps"
                                //     width="100%"
                                //     height="400px"
                                //     loading="lazy"
                                //     src={`https://www.google.com/maps/embed/v1/directions?origin=${origin.formatted_address}&destination=${destination.formatted_address}&key=AIzaSyDuBEmiBpMTiuhaAX-9ZhYGpRRto3k-T1I&units=metric`}
                                // ></iframe>
                                <MapsComponent
                                    origin={origin}
                                    destination={destination}
                                    setDirections={setDirections}
                                    directions={directions}
                                    setDistance={setDistance}
                                    setDuration={setDuration}
                                />
                            ) : (
                                // <GoogleMap
                                //     zoom={10}
                                //     mapContainerStyle={mapContainerStyle}
                                //     center={center}
                                // >
                                //     <DirectionsService
                                //         options={{
                                //             destination:
                                //                 destination.formatted_address,
                                //             origin: origin.formatted_address,
                                //             travelMode: "DRIVING",
                                //         }}
                                //         callback={directionsCallback}
                                //     />
                                //     {directions && (
                                //         <DirectionsRenderer
                                //             options={{
                                //                 directions: directions,
                                //             }}
                                //         />
                                //     )}
                                // </GoogleMap>
                                // <GoogleMap
                                //     mapContainerStyle={{
                                //         height: "100%",
                                //         width: "100%",
                                //     }}
                                //     center={{ lat: 0, lng: 0 }}
                                //     zoom={2}
                                // >
                                //     {directions !== null && (
                                //         <DirectionsRenderer
                                //             directions={directions}
                                //         />
                                //     )}
                                // </GoogleMap>
                                // <div class="col-lg-6 d-flex flex-column">
                                //     <div class="flex-grow-1">

                                //     </div>
                                // </div>
                                <div className={styles.iFrameContainer}>
                                    <iframe
                                        title="Google Maps"
                                        width="100%"
                                        height="400px"
                                        loading="lazy"
                                        src="https://www.google.com/maps/embed/v1/view?zoom=10&center=51.5072,-0.1276&key=AIzaSyDuBEmiBpMTiuhaAX-9ZhYGpRRto3k-T1I"
                                    ></iframe>
                                </div>
                            )}
                        </div>
                        <div className={`${styles.box} mt-1`}>
                            {formValues.type === "distance" && (
                                <div className="row">
                                    <div className="col-6">
                                        <div className="row gy-2">
                                            <div className="col-sm-12 col-md-4 my-md-auto text-center">
                                                <img
                                                    src="images/step1-marker.png"
                                                    alt="route marker"
                                                    className={`img-fluid ${styles.mobImageSize}`}
                                                />
                                            </div>
                                            <div className="col-sm-12 col-md-8 my-md-auto text-center text-md-start">
                                                <span
                                                    className={
                                                        styles.calculationHeading
                                                    }
                                                >
                                                    Total Distance
                                                </span>
                                                <div
                                                    className={styles.break}
                                                ></div>
                                                <span
                                                    className={
                                                        styles.calculationHeading
                                                    }
                                                >
                                                    {distance}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-6 border-start border-2 border-dark">
                                        <div className="row gy-2">
                                            <div className="col-sm-12 col-md-4 my-md-auto text-center">
                                                <img
                                                    src="images/step1-time.svg"
                                                    alt="route marker"
                                                    className={`img-fluid ${styles.mobImageSize}`}
                                                />
                                            </div>
                                            <div className="col-sm-12 col-md-8 my-md-auto text-center text-md-start">
                                                <span
                                                    className={
                                                        styles.calculationHeading
                                                    }
                                                >
                                                    Total Time
                                                </span>
                                                <div
                                                    className={styles.break}
                                                ></div>
                                                <span
                                                    className={
                                                        styles.calculationHeading
                                                    }
                                                >
                                                    {duration}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {formValues.type === "hourly" && (
                                <div className="fw-bold text-center">
                                    Note: You can take the car upto 10 miles per
                                    hour
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {/* {origin && destination && distance && (
                <DirectionsService
                    options={{
                        destination: destination.formatted_address,
                        origin: origin.formatted_address,
                        travelMode: "DRIVING",
                        drivingOptions: {
                            departureTime: new Date(Date.now()),
                            trafficModel: "pessimistic",
                        },
                    }}
                    callback={directionsCallback}
                />
            )} */}
            </div>
        </>
    );
};

export default StepOne;
